import { useEffect, useState, useRef, useMemo } from 'react';
import { Card, Row, Col, Form, Input, DatePicker, Button, Select } from 'antd';
import { headerStyle, rowStyle } from 'shared/styles/baseStyle';
import  EndPoints from 'shared/endPoints/EndPoints.json';
import  Validations from 'shared/validations/Validations.json';
import { useHistory, useLocation } from "react-router-dom";
import {getToday} from 'shared/utils/dateUtils';
import moment from 'moment';
import Status from './Status';

export default function SearchReportStatus() {

    const { search } = useLocation()
    const queryParams = useMemo(() => new URLSearchParams(search), [search])
    const dateFormat = 'D/M/YYYY';
    const [endPoint, setEndPoint] = useState()
    const defaultExportFilename = `Anytime_BTMStatusReport_new_${getToday().today}`
    const [exportFilename, setExportFilename] = useState(defaultExportFilename)
    const [form] = Form.useForm();
    const myRef = useRef();
    const history = useHistory();


    const formItemLayout = {
        labelCol: {
            span: 10
        },
        wrapperCol: {
            span: 12
        },
    };

    const executeScroll = () => myRef.current.scrollIntoView({ behavior: 'smooth' });


    useEffect(() => {
        const channelPrefix = queryParams.get('channel') === '1' ? 'AN_' : 'IM_'
        form.setFieldsValue({
            'policyNumber': queryParams.get('policyNumber'),
            'plateNumber': queryParams.get('plateNumber'),
            'startDateFrom': queryParams.get('startDateFrom') ? moment(queryParams.get('startDateFrom'), dateFormat) : null,
            'startDateTo': queryParams.get('startDateTo') ? moment(queryParams.get('startDateTo'), dateFormat) : null,
            'endDateFrom': queryParams.get('endDateFrom') ? moment(queryParams.get('endDateFrom'), dateFormat) : null,
            'endDateTo': queryParams.get('endDateTo') ? moment(queryParams.get('endDateTo'), dateFormat) : null,
            'monthsOfContract': queryParams.get('monthsOfContract'),
            'channel':queryParams.get('channel') ? queryParams.get('channel'):'ALL'
        })
        setExportFilename(queryParams.get('channel') ? `${channelPrefix}${defaultExportFilename}` :defaultExportFilename)
        setEndPoint(`${EndPoints.REPORTS.GETSTATUS}?${queryParams.toString()}`);
    }, [queryParams, form])

    const onFinish = (fieldsValues) => {
        const values = {
            ...fieldsValues,
            'startDateFrom': fieldsValues.startDateFrom?.format(dateFormat),
            'startDateTo': fieldsValues.startDateTo?.format(dateFormat),
            'endDateFrom': fieldsValues.endDateFrom?.format(dateFormat),
            'endDateTo': fieldsValues.endDateTo?.format(dateFormat),
            'monthsOfContract': fieldsValues.monthsOfContract ? parseInt(fieldsValues.monthsOfContract, 10) : null,
            'channel': fieldsValues.channel !== 'ALL' ? fieldsValues.channel: null
        }
        Object.keys(values).forEach(key => values[key] === null || values[key] === undefined || values[key] === '' ? delete values[key] : values[key]);
        const params = new URLSearchParams(values);
        history.replace({ search: `?${params}` });
        setEndPoint(`${EndPoints.REPORTS.GETSTATUS}?${params}`);
        executeScroll();
    };

    return (
        <>
            <Card type="inner" headStyle={headerStyle} title="Συμπληρώστε οποιοδήποτε από τα πεδία και στη συνέχεια πατήστε το κουμπί Αναζήτηση" >
                <Row style={rowStyle}>
                    <Col style={{ color: 'black' }} span={24}>Κριτήρια Αναζήτησης</Col>
                </Row>
                <Form
                    {...formItemLayout}
                    form={form}
                    onFinish={onFinish}
                >
                    <Row>
                        <Col span={12} >
                            <Form.Item
                                label="Αριθμός Συμβολαίου:"
                                name="policyNumber"
                                rules={[{ pattern: new RegExp(Validations.POLICYNUMBER.REGEX), message: Validations.POLICYNUMBER.MESSAGE }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item
                                label="Αριθμός Κυκλοφορίας:"
                                name="plateNumber"
                                rules={[{ pattern: new RegExp(Validations.PLATENUMBER.REGEX), message: Validations.PLATENUMBER.MESSAGE }]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item name="startDateFrom" label="Ημερομηνία Έναρξης Από:" >
                                <DatePicker style={{ width: '90%' }} format={dateFormat} />
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item name="startDateTo" label="Ημερομηνία Έναρξης Έως:" >
                                <DatePicker style={{ width: '90%' }} format={dateFormat} />
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item name="endDateFrom" label="Ημερομηνία Λήξης Από:" >
                                <DatePicker style={{ width: '90%' }} format={dateFormat} />
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item name="endDateTo" label="Ημερομηνία Λήξης Έως:" >
                                <DatePicker style={{ width: '90%' }} format={dateFormat} />
                            </Form.Item>
                        </Col>
                        <Col span={12} >
                            <Form.Item name="channel" label="Channel:" >
                                <Select defaultValue="ALL" options={[{value:'1', label:'Anytime'},{value:'2', label:'IM'},{value:'ALL', label:'ALL'}]} />
                            </Form.Item>
                        </Col>
                        <Col span={8} offset={10} >
                            <Form.Item>
                                <Button htmlType="submit" style={{ backgroundColor: '#e6e6e6' }} >
                                    Αναζήτηση
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
            <Col ref={myRef}>
                <Status endPoint={endPoint} exportFilename={exportFilename} />
            </Col>
        </>
    );
}